import React from 'react'
import VoteButton from './VoteButton';

export default function Vote5(props) {
    const { themeData } = props;

    const handleStatus = () => {
        switch (themeData.win){
            case "none": return (themeData && themeData.type === "end" ? "vote-end" : "");
            case "16cha": return "winner-16cha";
            case "calpis": return "winner-calpis";
            case "same": return "draw";
            default: return "";
        }
    }

    return (<>
        <div className="round round5"></div>
        <div className="vote-title title5"></div>
        <div className="vote-desc">
            <div>你知道中秋節是月老生日嗎?據說今天告白成功機率最高!</div>
            <div>喜歡的 他/她 正在找飲料，你要用哪個話術撩爆 他/她?</div>
        </div>
        <div className={`vote-bg round5 ${handleStatus()}`}></div>
        <div className="vote-chat-container">
            <div className="vote-chat cha">
                <div className="vote-chat-top"></div>
                <div className="vote-chat-content">
                    <div>
                        <div className="title">#東方養生撩法</div>
                        <div className="desc">「6次談心+6句肺腑之言+4次氣味相投，化為16次怦然心動，讓我像愛上十六茶一樣也愛上你!」</div>
                    </div>
                    <VoteButton voteType="cha" week="5">
                        <button className="common-btn pink" disabled={themeData && themeData.type !== "start" ? true : false}>{themeData && themeData.type === "end" ? "投票結束" : "投票"}</button>
                    </VoteButton>
                </div>
                <div className="vote-chat-bottom"></div>
            </div>
            <div className="vote-chat calpis">
                <div className="vote-chat-top"></div>
                <div className="vote-chat-content">
                    <div>
                        <div className="title">#好感發酵征服法</div>
                        <div className="desc">「願我的好如『可爾必思』乳酸菌般，在你體內一天天發酵，幫你消化掉所有不開心!」</div>
                    </div>
                    <VoteButton voteType="calpis" week="5">
                        <button className="common-btn pink" disabled={themeData && themeData.type !== "start" ? true : false}>{themeData && themeData.type === "end" ? "投票結束" : "投票"}</button>
                    </VoteButton>
                </div>
                <div className="vote-chat-bottom"></div>
            </div>
        </div>
    </>)
}